module.exports = __webpack_public_path__ + "files/a26f9111f690efd57958ebe3468ac3a4.png";